import script from "./UnifiedPaneToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./UnifiedPaneToolbar.vue?vue&type=script&setup=true&lang=js"

import "./UnifiedPaneToolbar.vue?vue&type=style&index=0&id=2fa9a35a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa9a35a"]])

export default __exports__